// -----------------------------------------------------------------
// <copyright                                                       
//   file="Izenda.OtherSettingsConstants.js"                        
//   company="Izenda">                                              
//  Copyright (c) 2015 Izenda, Inc.                                 
//  ALL RIGHTS RESERVED                                             
//                                                                  
//  The entire contents of this file is protected by U.S. and       
//  International Copyright Laws. Unauthorized reproduction,        
//  reverse-engineering, and distribution of all or any portion of  
//  the code contained in this file is strictly prohibited and may  
//  result in severe civil and criminal penalties and will be       
//  prosecuted to the maximum extent possible under the law.        
//                                                                  
//  RESTRICTIONS                                                    
//                                                                  
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES           
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE                          
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS              
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET    
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.                 
//                                                                  
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED      
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE        
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE       
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT  
//  AND PERMISSION FROM IZENDA INC.                                 
//                                                                  
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  
//  ADDITIONAL RESTRICTIONS.                                        
// </copyright>                                                     
// -----------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  requiredConstraints(type) {
    return {
      presence: {
        presence: true,
        message: String.format(localizer.getText('COMMON_MESSAGES_REQUIRED'), type)
      }
    };
  },
  ARCHIVED_VERSIONS_MIN_VALUE: 0,
  ARCHIVED_VERSIONS_MAX_VALUE: 999999,
  MAXIMUM_SUBREPORT_LEVEL_MIN_VALUE: 1,
  MAXIMUM_SUBREPORT_LEVEL_MAX_VALUE: 3,
  CALENDAR_WEEKS: [
    {
      value: 1,
      get label() {
        return localizer.getText('COMMON_LABEL_SUNDAY');
      }
    },
    {
      value: 2,
      get label() {
        return localizer.getText('COMMON_LABEL_MONDAY');
      }
    },
    {
      value: 3,
      get label() {
        return localizer.getText('COMMON_LABEL_TUESDAY');
      }
    },
    {
      value: 4,
      get label() {
        return localizer.getText('COMMON_LABEL_WEDNESDAY');
      }
    },
    {
      value: 5,
      get label() {
        return localizer.getText('COMMON_LABEL_THURSDAY');
      }
    },
    {
      value: 6,
      get label() {
        return localizer.getText('COMMON_LABEL_FRIDAY');
      }
    },
    {
      value: 7,
      get label() {
        return localizer.getText('COMMON_LABEL_SATURDAY');
      }
    }    
  ],


};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.OtherSettingsConstants.js